export default "__VITE_ASSET__PEVQtof4__"